import axiosClientFSR from "../axiosClientFSR";

export const identityHistoryFSR = {
    get: (param) => {
        return axiosClientFSR.get('/identiryhistory/list-scylla', {
            params: param
        })
    },
}